import React from "react";
import Meta from "components/Meta";
import Job from "components/Job";
import { requireAuth } from "util/auth";

function JobPage(props) {
  return (
    <>
      <Meta title="Job" />
      <Job
      	bg="light"
      	textColor="dark"
      	size="sm"
      	title="Job"
      	subtitle=""
      />
    </>
  );
}

export default requireAuth(JobPage);
